export const LANGUAGES_CODES = ['fr', 'en', 'de', 'it', 'es', 'zh'];

export const DEFAULT_LANGUAGE = 'en';

export const SITE_URL = 'https://optimhub.com';

// Localized slugs. Empty string = language home page.
export const ROUTE_SLUGS = {
  home: { fr: '', en: '', de: '', it: '', es: '', zh: '' },
  publishers: {
    fr: 'editeurs',
    en: 'publishers',
    de: 'publisher',
    it: 'editori',
    es: 'editores',
    zh: 'publishers'
  },
  onePager: {
    fr: 'one-pager',
    en: 'one-pager',
    de: 'one-pager',
    it: 'one-pager',
    es: 'one-pager',
    zh: 'one-pager'
  },
  terms: {
    fr: 'cgu',
    en: 'terms-of-service',
    de: 'agb',
    it: 'condizioni-di-utilizzo',
    es: 'condiciones-de-uso',
    zh: 'terms-of-service'
  },
  legalNotice: {
    fr: 'mentions-legales',
    en: 'legal-notice',
    de: 'impressum',
    it: 'note-legali',
    es: 'aviso-legal',
    zh: 'legal-notice'
  },
  privacy: {    fr: 'politique-confidentialite',
    en: 'privacy-policy',
    de: 'datenschutz',
    it: 'informativa-privacy',
    es: 'politica-de-privacidad',
    zh: 'privacy-policy'
  },
  serviceMsn: {
    fr: 'services/msn-microsoft-network',
    en: 'services/msn-microsoft-network',
    de: 'services/msn-microsoft-network',
    it: 'services/msn-microsoft-network',
    es: 'services/msn-microsoft-network',
    zh: 'services/msn-microsoft-network'
  },
  serviceCoupon: {
    fr: 'services/coupon-deals',
    en: 'services/coupon-deals',
    de: 'services/coupon-deals',
    it: 'services/coupon-deals',
    es: 'services/coupon-deals',
    zh: 'services/coupon-deals'
  },
  serviceCommerce: {
    fr: 'services/commerce-content',
    en: 'services/commerce-content',
    de: 'services/commerce-content',
    it: 'services/commerce-content',
    es: 'services/commerce-content',
    zh: 'services/commerce-content'
  },
  serviceBnpl: {
    fr: 'services/bnpl',
    en: 'services/bnpl',
    de: 'services/bnpl',
    it: 'services/bnpl',
    es: 'services/bnpl',
    zh: 'services/bnpl'
  },
  serviceAutocomplete: {
    fr: 'services/browser-autocomplete',
    en: 'services/browser-autocomplete',
    de: 'services/browser-autocomplete',
    it: 'services/browser-autocomplete',
    es: 'services/browser-autocomplete',
    zh: 'services/browser-autocomplete'
  },
  serviceDeepLink: {
    fr: 'services/deep-link-technology',
    en: 'services/deep-link-technology',
    de: 'services/deep-link-technology',
    it: 'services/deep-link-technology',
    es: 'services/deep-link-technology',
    zh: 'services/deep-link-technology'
  },
  bestNetwork: {
    fr: 'meilleur-reseau-affiliation',
    en: 'best-affiliate-network',
    de: 'bestes-affiliate-netzwerk',
    it: 'migliore-network-affiliazione',
    es: 'mejor-red-de-afiliacion',
    zh: 'best-affiliate-network'
  },
  bestPlatform: {
    fr: 'meilleure-plateforme-affiliation',
    en: 'best-affiliate-platform',
    de: 'beste-affiliate-plattform',
    it: 'migliore-piattaforma-affiliazione',
    es: 'mejor-plataforma-de-afiliacion',
    zh: 'best-affiliate-platform'
  },
  comparison: {
    fr: 'comparatif-reseaux-affiliation',
    en: 'affiliate-networks-comparison',
    de: 'affiliate-netzwerke-vergleich',
    it: 'confronto-network-affiliazione',
    es: 'comparativa-redes-de-afiliacion',
    zh: 'affiliate-networks-comparison'
  },
  cpaMonetization: {
    fr: 'monetisation-audience-cpa',
    en: 'cpa-audience-monetization',
    de: 'cpa-audience-monetarisierung',
    it: 'monetizzazione-audience-cpa',
    es: 'monetizacion-de-audiencia-cpa',
    zh: 'cpa-audience-monetization'
  },
  ecommerceAffiliation: {
    fr: 'affiliation-ecommerce',
    en: 'affiliate-marketing-for-ecommerce',
    de: 'affiliate-marketing-ecommerce',
    it: 'affiliazione-ecommerce',
    es: 'afiliacion-para-ecommerce',
    zh: 'affiliate-marketing-for-ecommerce'
  }
};

export const SEO_PAGE_KEYS = [
  'bestNetwork',
  'bestPlatform',
  'comparison',
  'cpaMonetization',
  'ecommerceAffiliation'
];

export const SERVICE_KEYS = [
  'serviceMsn',
  'serviceCoupon',
  'serviceCommerce',
  'serviceBnpl',
  'serviceAutocomplete',
  'serviceDeepLink'
];

export const routePath = (key, lang) => {
  const slug = ROUTE_SLUGS[key]?.[lang];
  return slug ? `/${lang}/${slug}` : `/${lang}`;
};

export const routeUrl = (key, lang) => `${SITE_URL}${routePath(key, lang)}`;

export const routeKeyFromPath = (pathname) => {
  const [, lang, ...rest] = pathname.split('/');
  if (!LANGUAGES_CODES.includes(lang)) return null;
  const slug = rest.join('/').replace(/\/$/, '');
  const entry = Object.entries(ROUTE_SLUGS).find(([, slugs]) => slugs[lang] === slug);
  return entry ? { key: entry[0], lang } : null;
};
